exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.bedSelector {\n  max-width: 200px;\n}\n.bedAssignmentLabel {\n  margin-right: 10px;\n  vertical-align: m;\n}\n.selectedRow {\n  background-color: #39b54a !important;\n}\n.roomName {\n  color: #39b54a;\n  font-size: 14px;\n  font-weight: 700;\n}\n.unSelectedRow {\n  background-color: #fff;\n}\n", ""]);

// exports
